import React from 'react';

function PieChart({ data, size = 80 }) {
  // Calculate total and percentages
  const total = data.reduce((sum, item) => sum + item.value, 0);
  
  if (total === 0) {
    return (
      <div style={{ 
        width: size, 
        height: size, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        fontSize: '0.75rem',
        color: '#6b7280'
      }}>
        No data
      </div>
    );
  }
  
  const center = size / 2;
  const radius = size / 2 - 4; // Leave some padding
  
  // Create path segments
  let cumulativeAngle = 0;
  const segments = data.map((item, index) => {
    const percentage = item.value / total;
    const angle = percentage * 2 * Math.PI;
    
    const startAngle = cumulativeAngle;
    const endAngle = cumulativeAngle + angle;
    
    const x1 = center + radius * Math.cos(startAngle);
    const y1 = center + radius * Math.sin(startAngle);
    const x2 = center + radius * Math.cos(endAngle);
    const y2 = center + radius * Math.sin(endAngle);
    
    const largeArcFlag = angle > Math.PI ? 1 : 0;
    
    const pathData = [
      `M ${center} ${center}`,
      `L ${x1} ${y1}`,
      `A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2}`,
      'Z'
    ].join(' ');
    
    cumulativeAngle += angle;
    
    return {
      path: pathData,
      color: item.color,
      percentage: Math.round(percentage * 100)
    };
  });
  
  return (
    <div style={{ position: 'relative', width: size, height: size }}>
      <svg width={size} height={size}>
        {/* Background circle */}
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="#f3f4f6"
          stroke="#e5e7eb"
          strokeWidth="1"
        />
        
        {/* Data segments */}
        {segments.map((segment, index) => (
          <path
            key={index}
            d={segment.path}
            fill={segment.color}
            stroke="#ffffff"
            strokeWidth="1"
          />
        ))}
      </svg>
      
      {/* Center text showing total */}
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        fontSize: '0.75rem',
        fontWeight: 'bold',
        textAlign: 'center',
        color: '#374151'
      }}>
        {total}
      </div>
    </div>
  );
}

export default PieChart; 